export default __webpack_public_path__ + "static/media/teaser_02.53765c70.png";